import { api } from './api';

/**
 * Retrieve weekly computations for a given patient.
 */
export const fetchWeeklyComputations = async ({ qi, patient, plan }) => {
    const response = await api.post('/cheart/weekly', {
        qi,
        patient,
        plan
    });
    return response.data;
};

/**
 * Retrieve weekly computations for a given group.
 */
export const fetchWeeklyGroupComputations = async ({ qi, group }) => {
    const response = await api.post('/cheart/weekly', {
        qi,
        group
    });
    return response.data;
};
